module.exports =
{

  _init: function ()
  {
    $('#sec1').on('shown.bs.collapse', function () {
     
        var panel = $(this).find('.guarantee-accordion-body-flex');
         
        $('html, body').animate({
            scrollTop: panel.offset().top - 200
        }, 500);
         
    });
    $('#sec2').on('shown.bs.collapse', function () {
     
        var panel = $(this).find('.guarantee-accordion-body-flex');
         
        $('html, body').animate({
            scrollTop: panel.offset().top - 200
        }, 500);
         
    });
    $('#sec3').on('shown.bs.collapse', function () {
     
        var panel = $(this).find('.guarantee-accordion-body-flex');
         
        $('html, body').animate({
            scrollTop: panel.offset().top - 200
        }, 500);
         
    });
  },

}